
<div class="c-audio-player-portal" [class.fixed]="positionFixed">
    <ng-container *ngFor="let audioData of audioDataList">
        <div class="row" style="width: 100%;margin:0">
            <app-audio-player style="width: calc(97% - 6px)" [data]="audioData"></app-audio-player>
            <button style="width: calc(3% + 6px);text-shadow: 0 0 0 #005073;color: transparent;border:none" class="btn close" (click)="deleteReproductor(audioData)">❌</button>
        </div>
    </ng-container>
</div>